import React, { useState } from 'react'

import OrdersSectionTabs from 'orders/sectionTabs'
import CartTable from './cartTable'
import ErrorBoundary from 'uiComponents/errorBoundary'
import { Alert } from '@mui/material'
import { useHasFeature } from 'features'
import { SortProps } from 'uiComponents/table/reactTable'
import CartExportModal from './export/cartExportModal'
import './cartPage.scss'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import { Trans } from 'translations'

const Cart: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const isOpenReservationWarningShown = useHasFeature('show_open_reservation_hidden_warning')
    const areFiltersEnabled = useHasFeature('show_reservation_filters')
    const reservationExportEnabled = useHasFeature('reservation_export_enabled')
    const [sortingState, setSortingState] = useState<SortProps | null>(null)
    const [isExportModalShown, setIsExportModalShown] = useState(false)
    const isExportShown = areFiltersEnabled && reservationExportEnabled

    return (
        <div id="cart__elem">
            <OrdersSectionTabs />
            {isOpenReservationWarningShown && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    <Trans
                        i18nKey="orders.cart.openReservationWarning"
                        components={{ anchor: <a href="mailto:support@convious.com" /> }}
                    />
                </Alert>
            )}
            <div>
                <CartTable
                    onSortChange={setSortingState}
                    onExport={isExportShown ? () => setIsExportModalShown(true) : undefined}
                />
            </div>
            <ErrorBoundary>{children}</ErrorBoundary>
            <BaseKnowledgeLink link="https://support.convious.com/help/pending-reservations" />
            {isExportModalShown && <CartExportModal onClose={() => setIsExportModalShown(false)} sort={sortingState} />}
        </div>
    )
}

export default Cart
